<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-button slot="start" fill="clear" (click)="close()">Cancel</ion-button>
    <ion-title>Create Plan</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div sxPadding="medium" sxCol sxGap="10px">
    <super-input label="Plan Name" [(value)]="createPlanDto.name"></super-input>
    <super-button [action]="create">Create</super-button>
  </div>


</ion-content>
